export default __webpack_public_path__ + "static/media/acm_close_icon.e8451c70.svg";